module.exports = __webpack_public_path__ + "img/data_source_scheme.f53311ec.png";